import { Link } from "@inertiajs/react";
import Icon from "hardcover-ui/components/Icon";
import faChevronRight from "icons/solid/chevron-right.svg";
import Text from "hardcover-ui/components/Text";
import {
  CurrentlyReadingStatus,
  ReadStatus,
} from "components/shared/UserBookStatuses";
import {
  UserBookSerializersUserBookStatusList,
  UserSerializersUserByline,
} from "types/serializers";
import CoverLink from "components/Cover/CoverLink";
import { BookButton } from "features/BookButton";

export interface Props {
  user: UserSerializersUserByline;
  lists: UserBookSerializersUserBookStatusList[];
}

export default function UserBooksByStatusTopList({ user, lists }: Props) {
  return (
    <div className="divide-y divide-secondary">
      {lists.length ? (
        lists.map((list) => (
          <div className="pb-4" key={`profile-status-lists-${list.id}`}>
            <Link
              href={`/@${user.username}/books/${list.slug}`}
              className="flex justify-between hover:bg-secondary rounded-lg transition-colors space-x-2 p-4"
            >
              <p>
                <span className="font-semibold">{list.status}</span>{" "}
                <span className="px-2 py-0.5 rounded-full bg-secondary">
                  {list.booksCount.toLocaleString()}
                </span>
              </p>
              <Icon icon={faChevronRight} size="md" />
            </Link>

            {list.id === CurrentlyReadingStatus.id ||
            list.id === ReadStatus.id ? (
              <div className="flex flex-row overflow-scroll gap-4">
                {list.userBooks.length ? (
                  list.userBooks.map((userBook) => (
                    <div
                      key={`user-book-${userBook.id}`}
                      className="flex flex-col items-center gap-4"
                    >
                      <CoverLink book={userBook.book} size="md" />
                      <BookButton
                        size="sm"
                        bookId={userBook.bookId}
                        referrerUserId={userBook.userId}
                      />
                    </div>
                  ))
                ) : (
                  <></>
                )}
              </div>
            ) : (
              false
            )}
          </div>
        ))
      ) : (
        <Text variant="secondary" as="p">
          Looks like you haven't added any books to Hardcover... yet! Try{" "}
          <Link href="/account/imports" className="underline hover:no-underline">
            importing your library
          </Link>{" "}
          or search for a book and save it.
        </Text>
      )}
    </div>
  );
}
